import Container from "./Container";

export default function Navbar() {
  return (
    <div
      id="myNav"
      className="hidden bg-white w-screen fixed top-0 transition-all ease-in-out duration-300 pt-5"
    >
      <Container className="flex justify-between">
        <button>
          <img
            src={`${window.localhost}/img/logo_creatifa_new.png`}
            className="h-8"
            alt="Creatifa Studio Logo"
          />
        </button>
      </Container>
    </div>
  );
}
